// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-search[data-v-5837dd12] {\n  text-align: center;\n  align-self: baseline;\n}\n.empty-search .v-icon[data-v-5837dd12] {\n  width: 100px;\n  height: 100px;\n  font-size: 3rem;\n  border-radius: 50%;\n}\n.theme--light.empty-search[data-v-5837dd12] {\n  color: rgba(0, 0, 0, 0.6);\n  background-color: #F9F9F9;\n}\n.theme--dark.empty-search[data-v-5837dd12] {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #21272D;\n}", ""]);
// Exports
module.exports = exports;
